import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';

import { logHelpWidgetWidgetClose } from '../../bi/biLogger';
import { dispatch } from '../../store';

export const collapseWidget = (closingTrigger: WidgetClosingTrigger): void => {
  dispatch('widget/expanded', false);
  logHelpWidgetWidgetClose(closingTrigger);
};
